<template>
    <div class="loginbg" style="display: none;">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form id="loginCustomerForm">
                            <div class="form-group">
                                <label for="inputEmail1">Username</label>
                                <input id="inputEmail1" name="loginFormData.username" v-model="loginFormData.username" type="email" placeholder="Username" v-validate="'required|email'" class="form-control">
                                <small v-if="error.username" class="has-text-danger">{{ error.email[0] }}</small>
                                <span class="help is-danger" v-if="errors.first('loginFormData.username')" v-show="loginFormData.username != ''"><span class="color-c3202b float-l width-full font-text-regular-san">Username must be a valid email</span></span>
                                <span class="help is-danger" v-if="errors.has('loginFormData.username')" v-show="loginFormData.username == ''"><span class="color-c3202b float-l width-full font-text-regular-san">Username is required</span></span>
                            </div>

                            <div class="form-group">
                                <label for="inputPassword1">Password</label>
                                <input id="inputPassword1" name="loginFormData.password" v-model="loginFormData.password" type="password" placeholder="Password" v-validate="'required'" class="form-control">
                                <small v-if="error.password" class="has-text-danger">{{ error.password[0] }}</small>
                                <span v-show="errors.has('loginFormData.password')" v-if="errors.has('loginFormData.password')" class="help is-danger"><span class="color-c3202b float-l width-full font-text-regular-san">Password is required</span></span>
                            </div>
                            
                            <p v-if="fronterrors.length > 0">
                                <ui>
                                    <li v-for="fronterror in fronterrors" :key="fronterror.id"  style="text-align: center"><span class="color-c3202b float-l width-full font-text-regular-san">{{fronterror}}</span></li>
                                </ui>
                            </p>
                            <span class="color-c3202b float-l width-full font-text-regular-san" style="display : none;" id="errorMsg"></span>
                            <div>
                                <button id="loginbtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="attemptLogin()" >Login</button>
                                <router-link href="javascript:void(0)" v-bind:to="'/forgotpassword'">Forgot password?</router-link>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import EventBus from './event-bus';
    import {loginUrl, configs, getuserUrl} from '../config';
    import VeeValidate from "vee-validate";
    Vue.use(VeeValidate);
    import SessioMixin from '../mixins/sessionmixin';

    //import Autocomplete from 'vuejs-auto-complete'
    export default {
        name: 'Login',
        mixins: [SessioMixin],
        props: [''],
        components: {
        },
        data() {
            return {
                loginFormData: {
                    username: '',
                    password: '',
                },
                error: {},
                fronterrors: [],
                ssoUrl: '',
                projectSlug: '',
                token: '',
                username: '',
            }
        },
        beforeMount: function () {
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('token')) {
                this.token = urlParams.get('token');
                this.username = urlParams.get('username');

                this.getUserObj();
            }else{
                var api_token = localStorage.getItem("api_token");
                if(api_token == null) {
                    this.ssoUrl = process.env.VUE_APP_SSO_ROOT_URL;
                    this.projectSlug = process.env.VUE_APP_PROJECT_SLUG;
                    const redirectUrl = window.location.href;
                    
                    window.location.href = `${this.ssoUrl}/login?redirect=${encodeURIComponent(redirectUrl)}&slug=${this.projectSlug}`;
                }else{
                    this.$router.push("/listcustomer");
                }
                
            }
        },
        mounted: function () {
            // $('.navbar').hide();
            // $('.footer-main').hide();
            // if(window.location.pathname == "/login") {
            //     $(".app-sidebar-right").css("padding-left","0px");
            //     $(".app-sidebar-right").css("margin-top","0px");
            //     $(".app-sidebar-right").css({"-webkit-transition":"all 0.0s ease","-moz-transition":"all 0.0s ease","-o-transition":"all 0.0s ease","transition":"all 0.0s ease"});
            //     $(".loginbg").show();
            // }
        },
        methods: {
            getUserObj() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/autologinuser",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Authorization": "Bearer " + self.token,
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        username: self.username,
                    },
                    dataType: 'json',
                    success: function (data) {
                        window.localStorage.setItem("api_token", self.token);
                        window.localStorage.setItem("user_obj", JSON.stringify(data.content.user));
                        window.localStorage.setItem("menu_small", '1');
                        window.localStorage.setItem("app_year", data.app_year);

                        EventBus.$emit('logged-in', false, data.content.user["first_name"], data.content.user["last_name"], data.content.user["email"]);

                        self.$router.push("/listcustomer");
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else if (jqXHR.status == 401) {
                            // Clear previous data
                            localStorage.removeItem('user_obj');
                            localStorage.removeItem('api_token');
                            // Redirect to "/login" if user not authenticated
                            self.$router.push("/login");
                        }
                    }
                });
            },
            // attemptLogin() {
            //     this.$validator.validate().then(result => {
            //         if (result) {
            //             //console.log('LoginForm');
            //             var app = this;
            //             $('#errorMsg').hide();
            //             app.fronterrors = [];
            //             $.ajax({
            //                 url: process.env.ROOT_API + "/login",
            //                 type: "POST",
            //                 crossDomain: true,
            //                 data: app.loginFormData,
            //                 success: function (data) {
            //                     //console.log(data.content);
            //                     if (data.status == "success") {
            //                         $('.navbar').show();
            //                         //self.timezones = data.content;
            //                         window.localStorage.setItem("api_token", data.content.api_token);
            //                         window.localStorage.setItem("user_obj", JSON.stringify(data.content.user_obj));
            //                         window.localStorage.setItem("menu_small", '1');
            //                         window.localStorage.setItem("app_year", data.content.app_year);
            //                         /*app.$router.push("/");*/

            //                         EventBus.$emit('logged-in', false, data.content.user_obj["first_name"], data.content.user_obj["last_name"], data.content.user_obj["email"]);


            //                         app.$router.push("/listcustomer");
            //                     }
            //                     if (data.code == 201) {
            //                         if (data.content.username[0]) {
            //                             app.fronterrors.push(data.content.username[0]);
            //                         }
            //                         if (data.content.password[0]) {
            //                             app.fronterrors.push(data.content.password[0]);
            //                         }


            //                     }
            //                 },
            //                 error: function (jqXHR, exception) {
            //                     self.Registerbtn = "Register";
            //                     if (jqXHR.status == 0) {
            //                         self.registerError = "Remote server can not be reachable";
            //                     } else {
            //                         $('#errorMsg').show();
            //                         $('#errorMsg').html(jqXHR.responseJSON.message);
            //                     }
            //                 }
            //             });
            //             //
            //         }
            //     });
            // },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/StaffLogin.vue